import React from "react";
import "./../assets/css/components/trading_platforms.css";
import "./../assets/css/components/video_lessons.css";
import Global from "../assets/css/Global.module.css";
import TopBrokers from "../containers/TopBrokers";
import {attemptGetVideoTraders} from "../redux/actions/indexActions";
import {translate} from "react-i18next";
import {connect} from "react-redux";
import ModalVideo from "react-modal-video";
import "react-modal-video/scss/modal-video.scss";
import RightBanner from "../components/RightBanner";


class VideoTrader extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            video: null,
            isVideoModalOpened: false,
            videoId: null
        };
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (this.props.language !== prevProps.language) {
            this.props.attemptGetVideoTraders(
                this.props.language
            );
        }
    }

    componentDidMount() {
        this.props.attemptGetVideoTraders(
            this.props.language
        );
        if (this.props.videoTraders) {
            this.setState({video: this.props.videoTraders});
        }
    }

    componentDidUpdate(prevProps) {
        if (this.props.language !== prevProps.language) {
            this.props.attemptGetVideoTraders(this.props.language);
        }
    }

    render() {
        const {videoTraders} = this.props;
        const { t } = this.props;
        return (
            <div className="d-flex flex-wrap">
                <div className="container mb-4 d-flex flex-wrap">
                    <div className="video_less_wrap main_with_left">
                        <h1>{t("EXPERT_VIDEO_LESSONS")}</h1>
                        <div className={`d-flex flex-wrap ${Global.bg_wrap}`}>
                            {videoTraders ? videoTraders.map((item, index) => {
                                return (
                                    <div key={index} className="video_cont_blocks education-video">
                                        <div className={""}>
                                            <div
                                                className={"video_les"}
                                                style={{backgroundImage: `url(${item.images})`}}
                                                onClick={() => {
                                                    this.setState({isVideoModalOpened: true});
                                                    this.state.videoId = item.link
                                                }}
                                            >
                                                <div className={Global.yout_video_icn}>
                                                    <div/>
                                                </div>
                                            </div>
                                            <ModalVideo
                                                channel="youtube"
                                                isOpen={this.state.isVideoModalOpened}
                                                videoId={this.state.videoId}
                                                onClose={() => this.setState({isVideoModalOpened: false})}
                                            />
                                        </div>

                                        <div className="vid_cont_block_txt p-0">
                                            <div className="video_less_title">{item.title}</div>
                                            <p>{item.description}</p>
                                        </div>
                                    </div>
                                );
                            }) : ""}
                        </div>
                    </div>
                    <div className={Global.right_box_block}>
                        <div className={Global.expel_class}>
                            <TopBrokers/>
                        </div>
                        <RightBanner/>
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = (store, props) => {
    return {
        language: store.language,
        videoTraders: store.videoTraders,
    };
};

function mapDispatchToProps(dispatch) {
    return {
        attemptGetVideoTraders: (lang) =>
            dispatch(attemptGetVideoTraders(lang)),
    };
}

export default translate("common")(
    connect(mapStateToProps, mapDispatchToProps)(VideoTrader)
);
